/* eslint-disable */
import { isIosApp, isAndroidApp, isMobileApp } from './validator'
import { getUrlParam } from './nav-http-cookie'
import { getEpochAdjustedTime } from './common'

export const removeSpacesAndCapitalize = str => {
  return str
    .split(' ')
    .map(st => {
      const stw = st.replace(/-/g, '')
      return stw.charAt(0).toUpperCase() + stw.substr(1, stw.length)
    })
    .join('')
}

export const toJsDateObject = (dateString = '', dateFormat) => {
  const dateArray = dateString && dateString.split(' ')
  const cDateFormat = dateFormat || {
    weekDay: 0,
    month: 1,
    day: 2,
    time: 3,
    zone: 4,
    year: 5
  }
  const monthHash = {
    Jan: 1,
    Feb: 2,
    Mar: 3,
    Apr: 4,
    May: 5,
    Jun: 6,
    Jul: 7,
    Aug: 8,
    Sep: 9,
    Oct: 10,
    Nov: 11,
    Dec: 12
  }
  const hour = dateArray && dateArray[cDateFormat.time].split(':')[0]
  const minute = dateArray && dateArray[cDateFormat.time].split(':')[1]
  const year = dateArray && dateArray[cDateFormat.year]
  const month = monthHash[dateArray[cDateFormat.month]]
  const day = dateArray[cDateFormat.day]
  return new Date(`${year}/${month}/${day} ${hour}:${minute}`)
}
export const getLanguageMeta = () => {
  const domain = path(['location', 'hostname'], window) // window.location.hostname;
  switch (domain) {
    case 'www.cleartrip.ae':
    case 'uat.cleartrip.ae':
    case 'me.cleartrip.ae':
    case 'ae.cleartrip.sa':
      return { locale: 'AE', currency: 'AED', country: 'UAE', symbol: 'AED' }
    case 'bh.cleartrip.com':
    case 'uat.cleartrip.bh':
    case 'www.cleartrip.bh':
    case 'me.cleartrip.bh':
    case 'bh.cleartrip.sa':
      return { locale: 'BH', currency: 'BHD', country: 'BHR', symbol: 'BHD' }
    case 'om.cleartrip.com':
    case 'uat.cleartrip.om':
    case 'www.cleartrip.om':
    case 'me.cleartrip.om':
    case 'om.cleartrip.sa':
      return { locale: 'OM', currency: 'OMR', country: 'OMN', symbol: 'OMR' }
    case 'kw.cleartrip.com':
    case 'uat.cleartrip.kw':
    case 'www.cleartrip.kw':
    case 'www.cleartrip.com.kw':
    case 'me.cleartrip.kw':
    case 'kw.cleartrip.sa':
      return { locale: 'KW', currency: 'KWD', country: 'KWT', symbol: 'KWD' }
    case 'qa.cleartrip.com':
    case 'uat.cleartrip.qa':
    case 'www.cleartrip.qa':
    case 'me.cleartrip.qa':
    case 'qa.cleartrip.sa':
      return { locale: 'QA', currency: 'QAR', country: 'QAT', symbol: 'BHD' }
    case 'www.cleartrip.sa':
    case 'uat.cleartrip.sa':
    case 'me.cleartrip.sa':
      return { locale: 'SA', currency: 'SAR', country: 'KSA', symbol: 'SAR' }
    case 'qa2.cleartrip.com':
      return { locale: 'IN', currency: 'INR', country: 'IN', symbol: '₹' }
    case 'meeg.flyin.com':
    case 'eg.flyin.com':
      return { locale: 'FEG', currency: 'EGP', country: 'EGY', symbol: 'EGP' }
    case 'ae.flyin.com':
    case 'meae.flyin.com':
      return { locale: 'FAE', currency: 'AED', country: 'UAE', symbol: 'AED' }
    case 'qa.flyin.com':
    case 'qa2.flyin.com':
    case 'www.flyin.com':
    case 'in.flyin.com':
    case 'me.flyin.com':
      return { locale: 'FSA', currency: 'SAR', country: 'KSA', symbol: 'SAR' }
    case 'me.cleartrip.com':
      return { locale: 'ME', currency: 'USD', country: 'ME', symbol: '$' }
    case 'www.cleartrip.me':
      return { locale: 'US', currency: 'USD', country: 'ME', symbol: '$' }
    case 'www.cleartrip.eu':
      return { locale: 'EU', currency: 'EUR', country: 'EUR', symbol: '€' }
    case 'www.cleartrip.pl':
      return { locale: 'EU', currency: 'EUR', country: 'EUR', symbol: '€' }
    default:
      return { locale: 'IN', currency: 'INR', country: 'IN', symbol: '₹' }
  }
}

export const formatCurrency = (val, curr, originalCurr) => {
  const value = val
  let currency = curr

  const path = (p, o) => {
    const reducerFunction = (xs, x) => {
      return xs && xs[x] ? xs[x] : null
    }
    return p.reduce(reducerFunction, o)
  }

  const getLanguageMeta = () => {
    const domain = path(['location', 'hostname'], window) // window.location.hostname;
    switch (domain) {
      case 'www.cleartrip.ae':
      case 'uat.cleartrip.ae':
      case 'me.cleartrip.ae':
      case 'ae.cleartrip.sa':
        return { locale: 'AE', currency: 'AED', country: 'UAE', symbol: 'AED' }
      case 'bh.cleartrip.com':
      case 'uat.cleartrip.bh':
      case 'www.cleartrip.bh':
      case 'me.cleartrip.bh':
      case 'bh.cleartrip.sa':
        return { locale: 'BH', currency: 'BHD', country: 'BHR', symbol: 'BHD' }
      case 'om.cleartrip.com':
      case 'uat.cleartrip.om':
      case 'www.cleartrip.om':
      case 'me.cleartrip.om':
      case 'om.cleartrip.sa':
        return { locale: 'OM', currency: 'OMR', country: 'OMN', symbol: 'OMR' }
      case 'kw.cleartrip.com':
      case 'uat.cleartrip.kw':
      case 'www.cleartrip.kw':
      case 'www.cleartrip.com.kw':
      case 'me.cleartrip.kw':
      case 'kw.cleartrip.sa':
        return { locale: 'KW', currency: 'KWD', country: 'KWT', symbol: 'KWD' }
      case 'qa.cleartrip.com':
      case 'uat.cleartrip.qa':
      case 'www.cleartrip.qa':
      case 'me.cleartrip.qa':
      case 'qa.cleartrip.sa':
        return { locale: 'QA', currency: 'QAR', country: 'QAT', symbol: 'BHD' }
      case 'www.cleartrip.sa':
      case 'uat.cleartrip.sa':
      case 'me.cleartrip.sa':
        return { locale: 'SA', currency: 'SAR', country: 'KSA', symbol: 'SAR' }
      case 'me.cleartrip.com':
        return { locale: 'ME', currency: 'USD', country: 'ME', symbol: '$' }
      case 'www.cleartrip.me':
        return { locale: 'US', currency: 'USD', country: 'ME', symbol: '$' }
      case 'www.cleartrip.eu':
        return { locale: 'EU', currency: 'EUR', country: 'EUR', symbol: '€' }
      case 'www.cleartrip.pl':
        return { locale: 'EU', currency: 'EUR', country: 'EUR', symbol: '€' }
      default:
        return { locale: 'IN', currency: 'INR', country: 'IN', symbol: '₹' }
    }
  }

  const getLocaleByCurrency = (c = 'INR') => {
    const locales = {
      INR: 'en-IN',
      AED: 'en-IN',
      OMR: 'en-IN',
      KWD: 'en-IN',
      BHD: 'en-IN',
      SAR: 'en-IN'
    }
    return locales[c]
  }

  const getCurrency = (c = 'INR') => {
    const langMeta = getLanguageMeta()
    return langMeta.c
  }
  if (!currency) {
    currency = getCurrency()
  }

  const getCurrencyFraction = (c, currencyPrecisionMap = {}) => {
    const precision =
      currencyPrecisionMap[c] !== undefined ? currencyPrecisionMap[c] : 2
    switch (currency) {
      case 'KWD':
        return {
          minimumFractionDigits: precision,
          maximumFractionDigits: precision,
          enabled: true
        }
      default:
        return { minimumFractionDigits: 0 }
    }
  }

  const locale = getLocaleByCurrency(currency)
  const fraction = getCurrencyFraction(currency)

  const formatted = (
    (fraction.enabled && parseFloat(value)) ||
    parseInt(value, 10)
  ).toLocaleString(locale, {
    style: 'currency',
    currency,
    ...fraction
  })
  return formatted
}
export const getGtmId = () => {
  const locale = getLanguageMeta().locale;
  switch (locale) {
    case 'OM':
      return 'GTM-T5FKQJC';
    case 'QA':
      return 'GTM-PF5GQK2';
    case 'BH':
      return 'GTM-MFT3QG7';
    case 'KW':
      return 'GTM-N37L6NP';
    case 'SA':
      return 'GTM-T96QGPF';
    case 'AE':
      return 'GTM-5Z82S8M';
    case 'FEG':
    case 'FSA':
    case 'FAE':
      return 'GTM-5C26K9';
    default:
      return "";
  }

}
export const getCurrencyByReq = (
  value,
  currency = 'INR',
  maximumFractionDigits = currency === 'INR' ? 0 : 2
) => {
  const locales = {
    INR: 'en-IN',
    AED: 'en-IN',
    OMR: 'en-IN',
    KWD: 'en-IN',
    BHD: 'en-IN',
    SAR: 'en-IN',
    USD: 'en-US'
  }
  const minimumFractionDigits = maximumFractionDigits
  const locale = (locales && currency && locales[currency]) || 'en-IN'
  const formatted = parseFloat(value).toLocaleString(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits,
    maximumFractionDigits
  })
  return formatted
}

export const getFormattedDate = date => {
  if (date) {
    return date
      .toUTCString()
      .split(' ')
      .slice(0, 4)
      .join(' ')
  }
  return null
}
export const getTripIdForApp = () => {
  let tripId
  if (!isMobileApp() && (isIosApp() || isAndroidApp())) {
    if (window.location.search !== '') {
      tripId = getUrlParam('tripId')
    }
  } else {
    const arr = window.location.href
      .split('/')
      .filter(tkn => tkn !== '')
      .map((tkn, idx) => tkn)
    // eslint-disable-next-line
    tripId = arr[arr.length - 1].split('?')[0]
  }
  return tripId
}

function path(p, o) {
  const reducerFunction = (xs, x) => {
    return xs && xs[x] ? xs[x] : null
  }
  return p.reduce(reducerFunction, o)
}
const currencyData = [
  { locale: 'AE', currency: 'AED', country: 'UAE', symbol: 'AED' },
  { locale: 'BH', currency: 'BHD', country: 'BHR', symbol: 'BHD' },
  { locale: 'OM', currency: 'OMR', country: 'OMN', symbol: 'OMR' },
  { locale: 'KW', currency: 'KWD', country: 'KWT', symbol: 'KWD' },
  { locale: 'QA', currency: 'QAR', country: 'QAT', symbol: 'BHD' },
  { locale: 'SA', currency: 'SAR', country: 'KSA', symbol: 'SAR' },
  { locale: 'IN', currency: 'INR', country: 'IN', symbol: '₹' },
  { locale: 'ME', currency: 'USD', country: 'ME', symbol: '$' },
  { locale: 'US', currency: 'USD', country: 'ME', symbol: '$' },
  { locale: 'EU', currency: 'EUR', country: 'EUR', symbol: '€' },
  { locale: 'FEG', currency: 'EGP', country: 'KSA', symbol: 'EGP' },
  { locale: 'FSA', currency: 'SAR', country: 'KSA', symbol: 'SAR' },
  { locale: 'FAE', currency: 'AED', country: 'UAE', symbol: 'AED' }
]

export const getCurrencySymbolFrom = (value, key) => {
  return currencyData.find(element => element[key] === value).symbol
}

// Substracts given minutes from given time
// Input: (time:String, minutes:+ve integer). Eg: ("21:50", 45), ('00:10', 60)
// Output: "21:05", "23:10"
export const subtractMinutes = (time, minutesToReduce) => {
  const timeSplit = time.split(':')
  let note = ''
  let timeInMin =
    Number(timeSplit[0]) * 60 + Number(timeSplit[1]) - minutesToReduce
  if (timeInMin < 0) {
    note = ' * Previous Day'
    timeInMin += 24 * 60
  }
  let hours = Math.floor(timeInMin / 60)
  let minutes = timeInMin % 60
  if (hours < 10) {
    hours = `0${hours}`
  }
  if (minutes < 10) {
    minutes = `0${minutes} `
  }
  return `${hours}:${minutes}${note}`
}

export const padTime = time => (time >= 10 ? time : `0${time}`)

export const monthArray = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
]
export const weekArray = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
export const weekNameArray = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
]
export const weekMonthReducer = (newDate, epochFlag = true, isPWA = true) => {
  let returnDate = ''
  const date = newDate && (epochFlag ? getEpochAdjustedTime(newDate) : newDate)
  if (date) {
    const desktopDate = `${weekNameArray[date.getDay()]}, ${monthArray[date.getMonth()]
      } ${date.getDate()}`
    const mobileDate = `${weekArray[date.getDay()]}, ${date.getDate()} ${monthArray[date.getMonth()]
      }`
    returnDate = isPWA ? mobileDate : desktopDate
  }
  return returnDate
}
export const appendMobileViewURL = url => {
  let returnUrl = url
  if (isMobileApp()) {
    returnUrl = `${returnUrl}&MobileApp=true`
    if (isAndroidApp()) {
      returnUrl = `${returnUrl}&isAndroidApp=true`
    } else if (isIosApp()) {
      returnUrl = `${returnUrl}&isIosApp=true`
    }
  }
  return returnUrl
}

export const formatDateTime = dateStr => {
  const dateValue = new Date(dateStr)
  if (dateValue) {
    const time = dateValue
      .toLocaleDateString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      })
      .split(',')[1]
      .trim()
    const date = dateValue.getDate()
    const month = monthArray[dateValue.getMonth()]
    return `${time.toLowerCase()} , ${date} ${month}`
  }
  return null
}

export const getCurrencyByLocale = () => {
  const domain = path(['location', 'hostname'], window)
  switch (domain) {
    case 'www.cleartrip.ae':
    case 'uat.cleartrip.ae':
    case 'me.cleartrip.ae':
      return { locale: 'AE', currency: 'AED', country: 'UAE', symbol: 'AED' }
    case 'bh.cleartrip.com':
    case 'uat.cleartrip.bh':
    case 'www.cleartrip.bh':
    case 'bh.cleartrip.sa':
      return { locale: 'BH', currency: 'BHD', country: 'BHR', symbol: 'BHD' }
    case 'om.cleartrip.com':
    case 'uat.cleartrip.om':
    case 'www.cleartrip.om':
    case 'om.cleartrip.sa':
      return { locale: 'OM', currency: 'OMR', country: 'OMN', symbol: 'OMR' }
    case 'kw.cleartrip.com':
    case 'uat.cleartrip.kw':
    case 'www.cleartrip.kw':
    case 'www.cleartrip.com.kw':
    case 'kw.cleartrip.sa':
      return { locale: 'KW', currency: 'KWD', country: 'KWT', symbol: 'KWD' }
    case 'qa.cleartrip.com':
    case 'uat.cleartrip.qa':
    case 'www.cleartrip.qa':
    case 'qar.cleartrip.sa':
      return { locale: 'QA', currency: 'QAR', country: 'QAT', symbol: 'BHD' }
    case 'www.cleartrip.sa':
    case 'uat.cleartrip.sa':
    case 'me.cleartrip.sa':
      return { locale: 'SA', currency: 'SAR', country: 'KSA', symbol: 'SAR' }
    case 'me.cleartrip.com':
    case 'qa2me.cleartrip.com':
      return { locale: 'ME', currency: 'USD', country: 'ME', symbol: '$' }
    case 'www.cleartrip.me':
      return { locale: 'ME', currency: 'USD', country: 'ME', symbol: '$' }
    case 'www.cleartrip.eu':
      return { locale: 'EU', currency: 'EUR', country: 'EUR', symbol: '€' }
    case 'www.cleartrip.pl':
      return { locale: 'EU', currency: 'EUR', country: 'EUR', symbol: '€' }
    case 'www.cleartrip.co.za':
      return { locale: 'ZA', currency: 'ZAR', country: 'ZA', symbol: 'R' }
    case 'meeg.flyin.com':
    case 'eg.flyin.com':
      return { locale: 'FEG', currency: 'EGP', country: 'EGY', symbol: 'EGP' }
    case 'ae.flyin.com':
    case 'meae.flyin.com':
      return { locale: 'FAE', currency: 'AED', country: 'UAE', symbol: 'AED' }
    case 'qa.flyin.com':
    case 'qa2.flyin.com':
    case 'www.flyin.com':
    case 'in.flyin.com':
    case 'me.flyin.com':
      return { locale: 'FSA', currency: 'SAR', country: 'KSA', symbol: 'SAR' }
    default:
      return { locale: 'IN', currency: 'INR', country: 'IN', symbol: 'Rs.' }
  }
}